module.exports = __webpack_public_path__ + "static/media/modern-technologies.21145d4e.svg";